<!--
 * @Author: wanglibo
 * @LastEditors: wanglibo
 * @Description: h5视频列表，用在医院的宣教视频
-->
<template>
  <div class="videolist-page">
    <!-- <div class="page-title">加速康复指南</div> -->
    <div class="videolist-content">
      <div v-for="(video,key) in hospitalInfo.list || []" :key="key" class="video-item">
        <video controls
          :poster="video.poster"
          :src="video.src" />
        <div class="desc">{{ video.title }}</div>
      </div>
    </div>
    <div>
      <div style="text-align: center;font-size: 30px;margin-bottom: 10px;">祝您早日康复！</div>
      <div style="text-align: center;font-size: 16px;">{{ hospitalInfo.bottomTip }}</div>
    </div>
  </div>
</template>

<script>
import {videoListConfig} from '../utils/videoListConfig';
import {getQueryString} from '../utils/utils'
export default {
  name: 'VideoList',
  data() {
    return {
      hospitalInfo:{}
    }
  },
  created() {
    document.addEventListener("WeixinJSBridgeReady", function onBridgeReady() {
      // console.log("window", window)
      window.WeixinJSBridge.call('hideOptionMenu');
    })
  },
  mounted() {
    let tag=getQueryString('tag') || 'phrm';
    // console.log("tag",tag,videoListConfig)
    this.hospitalInfo=videoListConfig[tag]
    // console.log("hospitalInfo",this.hospitalInfo)
    document.title = videoListConfig[tag].title
  },
};
</script>

<style scoped>
.page-title {
  width: 100%;
  line-height: 40px;
  font-size: 16px;
  text-align: center;
  margin-bottom: 10px;
  background-color: #ededed;
}

.videolist-page {
  padding-bottom: 30px;
}

.videolist-content {
  box-sizing: border-box;
  width: 100%;
  /* height: 100vh; */
  padding: 10px 20px;
  margin-bottom: 20px;
}

.videolist-content .video-item {
  width: 100%;
  height: auto;
  background-color: aliceblue;
  margin-bottom: 20px;
  border-radius: 4px;
  overflow: hidden;

}

.videolist-content .video-item video {
  width: 100%;
  height: auto;
}

.videolist-content .video-item .desc {
  font-size: 14px;
  line-height: 38px;
  padding-left: 16px;

}
</style>
